'use client'

import { createContext, type ReactNode, useContext } from 'react'

import { useScrollspy } from './useScrollspy'

type ScrollspyRefsProviderType = ReturnType<typeof useScrollspy>['refs']
type ScrollspyActiveSlugProviderType = ReturnType<typeof useScrollspy>['activeSlug']

const ScrollspyRefsContext = createContext<ScrollspyRefsProviderType | null>(null)
const ScrollspyActiveSlugContext = createContext<ScrollspyActiveSlugProviderType | null>(null)

type Props = {
  children: ReactNode
  slugs: string[]
}

export const ScrollspyProvider = ({ children, slugs }: Props) => {
  const { activeSlug, refs } = useScrollspy(slugs)

  return (
    <ScrollspyRefsContext.Provider value={refs}>
      <ScrollspyActiveSlugContext.Provider value={activeSlug}>{children}</ScrollspyActiveSlugContext.Provider>
    </ScrollspyRefsContext.Provider>
  )
}

export const useScrollspyRefs = (): ScrollspyRefsProviderType => {
  const refs = useContext(ScrollspyRefsContext)

  if (!refs) throw new Error('useScrollspyRefs must be used within ScrollspyRefsProviderType')

  return refs
}

export const useScrollspyActiveSlug = (): ScrollspyActiveSlugProviderType => {
  const activeSlug = useContext(ScrollspyActiveSlugContext)

  if (activeSlug === null) throw new Error('useScrollspyActiveSlug must be used within ScrollspyActiveSlugProviderType')

  return activeSlug
}
